import { useCallback } from 'react'
import { useMutation } from '@apollo/client'
import { useWallet } from '@solana/wallet-adapter-react'
import { LOG_OUT } from 'api/auth/logout'
import { IS_PRIVY_AUTH } from 'app/auth-config'
import { isConnectWalletDialogOpenVar } from 'features/auth/store/dialogs'
import { clearSolanaWalletSession } from 'features/auth/utils/clear-solana-wallet-session'
import { getPrivySessionBridge } from '../session-bridge'

/**
 * Provider-agnostic sign in / sign out (FE-301).
 *
 * Sign out always ends the XYRO cookie session first, then the wallet adapter
 * and the Privy session, and reloads — the order the legacy `Logout` used,
 * so the app never keeps a half-closed session.
 */
export const useAuthSession = () => {
  const [commitLogOut, { loading }] = useMutation(LOG_OUT)
  const { disconnect } = useWallet()

  const signIn = useCallback(() => {
    if (IS_PRIVY_AUTH) {
      getPrivySessionBridge()?.login()
      return
    }

    isConnectWalletDialogOpenVar(true)
  }, [])

  const signOut = useCallback(async () => {
    await commitLogOut()
    await disconnect()
    clearSolanaWalletSession()
    if (IS_PRIVY_AUTH) await getPrivySessionBridge()?.logout()
    location.reload()
  }, [commitLogOut, disconnect])

  return { signIn, signOut, loading }
}
